export default __webpack_public_path__ + "static/media/Heal Rating Boost (4h).dd0cd07e.jpg";